import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';

import { ModalSoftUpdateComponent } from 'app/shared/components/modals/modal-soft-update/modal-soft-update.component';
import { ModalForceUpdateComponent } from 'app/shared/components/modals/modal-force-update/modal-force-update.component';
import { ConfigModalAnimation } from 'app/animations/config-modal-animation';
import { API } from 'app/shared/constants/app-service-constants';
import { PlatformService } from './platform.service';
import { build } from '../../../assets/build-number';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  constructor(
    private platform: Platform,
    private platformService: PlatformService,
    private modalController: ModalController,
    private animation: ConfigModalAnimation,
    private http: HttpClient,
  ) { }

  init() {
    if (!this.platformService.isCordova()) {
      return;
    }
    this.platform.ready().then(() => {
      this.checkAppVersion().subscribe((resp) => {
        if (resp.hardUpdate) {
          // this.showHardUpdateModal();
          // this.showSoftUpdateModal();
        }
      });
    });
  }

  getCurrentAppVersion(): string {
    return build.version;
  }

  checkAppVersion(): any {
    const twoDigits = this.getMajorAppVersion();

    return this.http.get(`${API.VALIDATION_APP_VERSION}?appVersion=v${twoDigits}`);
  }

  async showHardUpdateModal() {
    const forceUpdateModal = await this.modalController.create({
      component: ModalForceUpdateComponent,
      cssClass: 'modal-app-availability',
      enterAnimation: this.animation.getAnimations().enterAnimation,
      leaveAnimation: this.animation.getAnimations().leaveAnimation,
      componentProps: {},
      backdropDismiss: false,
    });

    await forceUpdateModal.present();
  }

  async showSoftUpdateModal() {
    const softUpdateModal = await this.modalController.create({
      component: ModalSoftUpdateComponent,
      cssClass: 'modal-app-availability soft-update',
      enterAnimation: this.animation.getAnimations().enterAnimation,
      leaveAnimation: this.animation.getAnimations().leaveAnimation,
      componentProps: {},
      backdropDismiss: false,
    });

    await softUpdateModal.present();
  }

  private getMajorAppVersion() {
    const buildVersion = build.version;
    const versionArr = buildVersion.split('.');
    const majorVersion = `${versionArr[0]}.${versionArr[1]}`;

    return majorVersion;
  }
}
